/**
 * Faz 9 hata metinleri (yapay zekâ, İçerik Stüdyosu, SEO önerileri, YouTube…). Vitrin girişi de hata metinlerini
 * gördüğü için `shared.tr.ts` → `errorsTr` içine yayılır (Faz 8 düzeniyle aynı; panel metinleri `ai.tr.ts`'de).
 */
export const aiErrorsTr = {
  youtube_not_configured:
    'YouTube bağlantısı yok veya test edilmedi. Entegrasyonlar ekranından API anahtarını girip test edin.',
  youtube_key_format:
    'API anahtarı biçimi hatalı (Google Cloud → Kimlik bilgileri → API anahtarı; "AIza" ile başlar, 39 karakter).',
  youtube_key_invalid: 'Google bu API anahtarını kabul etmedi.',
  youtube_key_restricted:
    'Anahtar kısıtlı: tarayıcı (HTTP yönlendiren) veya uygulama kısıtı sunucudan kullanımı engelliyor. Anahtarda IP kısıtı kullanın ve yalnızca YouTube Data API ile sınırlayın.',
  youtube_api_disabled:
    "Google Cloud projesinde YouTube Data API v3 etkin değil. API Kitaplığı'ndan etkinleştirin.",
  youtube_quota: 'YouTube günlük kotası doldu; yarın yeniden deneyin.',
  youtube_unreachable: "YouTube'a ulaşılamadı veya yanıt okunamadı. Daha sonra yeniden deneyin.",
  merchant_title_claims: 'Google başlığında hastalık önleme/tedavi iddiası olamaz.',
  merchant_title_too_long: 'Google başlığı en çok 150 karakter olabilir.',
  copilot_days: 'Dönem 7, 30 veya 90 gün olmalı.',
  copilot_question_required: 'Sorunuzu en az 3 karakterle yazın.',
  ai_translation_source_invalid: 'Kaynak yazı bu yazının çeviri grubunda değil.',
  ai_translation_too_long: 'Yazı tek seferde çevrilemeyecek kadar uzun (en çok 40.000 karakter).',
  ai_email_goal_required: 'Kampanyanın amacını en az 10 karakterle yazın.',
  ai_support_drafts_disabled:
    'Destek yanıt taslakları kapalı. İşletme sahibi Yapay zekâ ayarlarından açabilir (müşteri mesajı maskelenerek gönderilir).',
  studio_image_alt_required: 'Taslağa eklenen her görselin alt metni olmalı: ![alt metin](zt-file:…).',
  ai_image_prompt_invalid: 'Görsel tarifi 10 ile 1000 karakter arasında olmalı.',
  ai_image_invalid:
    'Sağlayıcının döndürdüğü görsel okunamadı; ücret sayıldıysa kullanım raporunda görünür. Yeniden deneyin.',
  ai_provenance_locked: 'Yapay zekâ ile üretilen görselin kaynağı değiştirilemez.',
  file_not_image: 'Dosya bir görsel değil.',
  studio_image_limit: 'En çok 20 içerik görseli eklenebilir.',
  studio_topic_required: 'Konu en az 3 karakter olmalı.',
  studio_country_invalid: 'Ülke iki harfli kod olmalı (ör. TR).',
  studio_source_url_invalid: 'Kaynak adresi http:// veya https:// ile başlayan geçerli bir adres olmalı.',
  studio_too_many_sources: 'En çok 20 kaynak eklenebilir.',
  studio_draft_too_long: 'Taslak en çok 100.000 karakter olabilir.',
  studio_path_invalid: 'İç bağlantı "/" ile başlayan bir site içi yol olmalı.',
  studio_archived: 'Proje arşivde; değiştirilemez.',
  studio_draft_empty: 'Aktarmak için önce taslak yazın.',
  studio_draft_invalid: 'Taslak blog biçimine çevrilemedi (çok uzun veya çok fazla öğe içeriyor).',
  studio_no_sources: 'Doğrulanacak kaynak yok. Önce kaynak ekleyip kaydedin.',
  studio_overwrite_confirm: 'Bu alanda içerik var; üzerine yazmak için onay verin.',
  studio_headings_required: 'Taslaktan önce başlıkları yazın veya yapay zekâyla plan oluşturun.',
  ai_output_invalid: 'Yapay zekânın yanıtı beklenen biçimde değildi; kayıt değiştirilmedi. Yeniden deneyin.',
  ai_not_configured:
    'Yapay zekâ sağlayıcısı bağlı değil (Kurulum Gerekli). Anahtarı Entegrasyonlar ekranından girip bağlantıyı test edin.',
  ai_not_enabled:
    'Yapay zekâ kapalı. İşletme sahibi Yapay zekâ ayarlarından aylık sınırı yazıp açık onay vermeli.',
  ai_budget_exceeded:
    'Aylık yapay zekâ harcama sınırına ulaşıldı (sınır {{limit}} USD, harcanan {{spent}} USD). Sınırı Yapay zekâ ayarlarından artırabilirsiniz.',
  ai_daily_limit: 'Günlük yapay zekâ istek sınırına ({{limit}}) ulaşıldı. Yarın yeniden deneyin.',
  ai_invalid_key: 'Sağlayıcı API anahtarını reddetti. Entegrasyonlar ekranında anahtarı yenileyin.',
  ai_invalid_settings: 'API anahtarı boş veya geçersiz biçimde.',
  ai_provider_rate_limited: 'Sağlayıcı istek sınırına takıldı. Birkaç dakika sonra yeniden deneyin.',
  ai_provider_overloaded: 'Sağlayıcı şu an yoğun. Biraz sonra yeniden deneyin.',
  ai_provider_rejected: 'Sağlayıcı isteği reddetti (model adı veya ayar hatalı olabilir).',
  ai_provider_timeout:
    'Sağlayıcı zamanında yanıt vermedi. İstek işlenmiş olabileceği için ayrılan tutar harcamaya sayıldı.',
  ai_provider_unreachable: 'Sağlayıcıya ulaşılamadı. Biraz sonra yeniden deneyin.',
  ai_provider_bad_response: 'Sağlayıcının yanıtı okunamadı.',
  ai_output_empty: 'Yapay zekâ boş yanıt döndü. Girdiyi değiştirip yeniden deneyin.',
  ai_refused: 'Yapay zekâ bu isteği yanıtlamadı. Girdiyi değiştirip yeniden deneyin.',
  ai_model_price_missing:
    '"{{model}}" modelinin fiyatı bilinmiyor. Harcama hesaplanabilsin diye önce fiyat tablosuna ekleyin.',
  ai_model_invalid: 'Model adı geçersiz (küçük harf, rakam, nokta ve tire).',
  ai_ack_required: 'Ücretli hizmeti açtığınızı onaylamanız gerekiyor.',
  month_invalid: 'Ay YYYY-AA biçiminde olmalı.',
  forecast_history: 'Geçmiş 8 ile 104 hafta arasında olmalı.',
  forecast_days: 'Gün sayısı 0 ile 365 arasında olmalı.',
  forecast_review: 'Gözden geçirme dönemi 1 ile 180 gün arasında olmalı.',
  forecast_overstock: 'Fazla stok eşiği 30 ile 730 gün arasında olmalı.',
  ai_limit_invalid: 'Aylık sınır 1 ile 10.000 USD arasında olmalı.',
  ai_daily_limit_invalid: 'Günlük istek sınırı 1 ile 5000 arasında olmalı.',
  ai_image_reserve_invalid: 'Görsel başına üst sınır 0,001 ile 5 USD arasında olmalı.',
  recommendation_window: 'Dönem 30 ile 730 gün arasında olmalı.',
  recommendation_min_buyers: 'En az farklı alıcı 2 ile 50 arasında olmalı (gizlilik için en az 2).',
  recommendation_confidence: 'Güven yüzde 0 ile 100 arasında olmalı.',
  recommendation_max: 'Ürün başına öneri 1 ile 20 arasında olmalı.',
};
